import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "tabbed-section-tools"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_view_tabs = _resolveComponent("ontos-view-tabs")!
  const _component_ontos_action_group = _resolveComponent("ontos-action-group")!
  const _component_ontos_section = _resolveComponent("ontos-section")!

  return (_openBlock(), _createBlock(_component_ontos_section, {
    divider: false,
    header: _ctx.tabs.length > 1
  }, _createSlots({
    title: _withCtx(() => [
      _createVNode(_component_ontos_view_tabs, {
        views: _ctx.tabs,
        "model-value": _ctx.current,
        overflow: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.pick($event)))
      }, null, 8, ["views", "model-value"])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", { tab: _ctx.current }, undefined, true)
    ]),
    _: 2
  }, [
    (_ctx.hasControls || _ctx.hasTools)
      ? {
          name: "controls",
          fn: _withCtx(() => [
            (_ctx.hasControls)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.$vuetify.display.smAndDown && !_ctx.plainControls)
                    ? (_openBlock(), _createBlock(_component_ontos_action_group, { key: 0 }, {
                        default: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "controls", { tab: _ctx.current }, undefined, true)
                        ]),
                        _: 3
                      }))
                    : _renderSlot(_ctx.$slots, "controls", { tab: _ctx.current }, undefined, true, 1)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.hasTools)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  _renderSlot(_ctx.$slots, "tools", { tab: _ctx.current }, undefined, true)
                ]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["header"]))
}